import { Link } from "react-router-dom";

const FooterLink = ({to, text}) => {
    return ( 
        <Link to={to} className="text-gray-400 block my-1 py-1 hover:text-gray-50">{text}</Link>
    );
}

export default FooterLink;